import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

import gameobjectsoundambiant from '@/gameobjects/soundambiant/soundambiant.js';

import {statenodeplayer} from '@/states/nodeplayer.js';
import {stateplayer} from '@/states/player.js';
import {stategame} from '@/states/game.js';

class ScriptPlayer extends HYPERCUBEJS.Script {

    $inputs;

    $rotation;

    $rotationcamera;

    /**
     * @type {vector3}
     */
    $translation;

    $timelightning;

    $locked;

    constructor() {

        super();

        this.$initializeinputs();

        this.$rotation = [0, 0, 0];
        this.$rotationcamera = [0, 0, 0];
        this.$translation = [0, 0, 0];

        this.$timelightning = 0;

        this.$locked = false;
    }

    $initializeinputs() {

        this.$inputs = {

            'a': false,
            'z': false,
            'e': false,
            'q': false,
            's': false,
            'd': false,
            'w': false,
            'ArrowUp': false,
            'ArrowLeft': false,
            'ArrowRight': false,
            'ArrowDown': false,
            'Enter': false,
            ' ': false,
            'm': false,
            'KeyW': false,
            'KeyA': false,
            'KeyS': false,
            'KeyD': false,
            'Space': false,
        };
    }

    /**
     *
     * @param {HYPERCUBEJS.Node} $other TODOOOOO
     */
    oncollide($timebeforecollision, $entity, $other) {

        // console.log($other.name, $timecollision);

        // stateplayer.setstate({

        //     ...stateplayer.getstate(),
        //     'jumping': false
        // });
    }

    // @TODO
    /**
     *
     * @param {HYPERCUBEJS.Node} $entity
     * @param {*} $event
     */
    oninput($entity, $event) {

        this.$translation = [0, 0, 0];

        if ($event.type === 'keydown'
        && this.$inputs.hasOwnProperty($event.code) === true) {

            // @TODO : replace par event.code
            this.$inputs[$event.code] = true;

            // console.log($event.key);
        }

        else if ($event.type === 'keyup'
        && this.$inputs.hasOwnProperty($event.code) === true) {

            // @TODO : replace par event.keyCode
            this.$inputs[$event.code] = false;
        }

        else if ($event.type === 'pointermove') {

            this.engine.deviceviewer.element.requestPointerLock();

            this.$locked = true;
        }

        else if ($event.type === 'blur') {

            this.$initializeinputs();
        }

        if ($event.type === 'pointermove'
        && this.$locked === true) {

            this.$rotation[1] += - $event.movementX / 20 / this.engine.deviceviewer.ratio();
            this.$rotationcamera[0] += - (Math.sign($event.movementY) * Math.max(Math.abs($event.movementY), 5)) / 20 / this.engine.deviceviewer.ratio();
        }

        if (this.$inputs['KeyW'] === true) {
            this.$translation[2] += -1;
            // $entity.audio.play();
        }
        if ((this.$inputs['Space'] === true || this.$inputs['ArrowUp'] === true || ($event.type === 'pointerdown' && $event.buttons === 1))
        && stateplayer.getstate().jumping === false
        && stateplayer.getstate().jumpcooldown <= 0) {

            stateplayer.setstate({

                'jumping': true,
                'jump': 2,
                'jumpcooldown': 700
            });
        }
        if (this.$inputs['KeyA'] === true) {
            this.$translation[0] += -1;
            // $entity.audio.play();
        }
        if (this.$inputs['KeyS'] === true) {
            this.$translation[2] += 1;
            // $entity.audio.play();
        }
        if (this.$inputs['KeyD'] === true) {
            this.$translation[0] += 1;
            // $entity.audio.play();
        }
        // if (this.$inputs['Enter'] === true) {
        //     stategame.setstate({

        //         ...stategame.getstate(),
        //         'mountain': true,
        //         'temple': true,
        //         'tree': true,
        //         // 'sky': true
        //     });
        // }
        // if (this.$inputs['ArrowLeft'] === true) {
        //     this.$rotation[1] += 1;
        // }
        // if (this.$inputs['ArrowRight'] === true) {
        //     this.$rotation[1] += -1;
        // }
        // if (this.$inputs['m'] === true) {
        //     const ambiant = gameobjectsoundambiant();
        //     ambiant.audio.play();
        //     ambiant.audio.loop = true;
        //     ambiant.rotate([...$entity.rotation]);
        //     ambiant.translate([...$entity.translation]);
        //     ambiant.translate([0, 1, 0]);
        //     this.scene.noderoot.addchild(ambiant);
        // }
        // if (this.$inputs['z'] === false
        // && this.$inputs['q'] === false
        // && this.$inputs['s'] === false
        // && this.$inputs['d'] === false) {
        //     // $entity.audio.pause();
        // }
    }

    // onpointerdown($entity) {

    //     $entity.parent.removechild($entity);
    // }

    // @TODO
    /**
     *
     * @param {HYPERCUBEJS.Node} $entity TODOOOOOOOOOOOOO
     */
    onstart($entity) {

        // statenodeplayer.setstate($entity);

        // @TODO : only if DeviceSpeaker

        // $entity.audio.loop = true;
    }

    /**
     *
     * @param {*} $timeframe
     * @param {HYPERCUBEJS.Node} $entity
     */
    ontick($timeframe, $entity) {

        const pertick = $timeframe / 1000;

        // const [lightx, lighty, lightz] = this.scene.lightdirectional.direction;

        // this.scene.setlightdirectional(new HYPERCUBEJS.LightDirectional('Light Directional', [Math.sin(performance.now() / 1000), lighty, Math.cos(performance.now() / 1000)], [1.0, 1.0, 0.8]));

        // if (stategame.getstate().light === true) {

        //     const speed = 1;

        //     const fogorigin = [this.scene.fog.distancefogbegin, this.scene.fog.distancefogmaximum, this.scene.fog.density];
        //     const foggoal = [-16, 64, 0.8];

        //     const difference = HYPERCUBEJS.VECTOR3.subtract(foggoal, fogorigin);
        //     const forward = HYPERCUBEJS.VECTOR3.multiplyscalar(difference, pertick * speed);
        //     const fog = HYPERCUBEJS.VECTOR3.add(fogorigin, forward);

        //     this.scene.setfog(new HYPERCUBEJS.Fog(this.scene.fog.color, fog[0], fog[1], fog[2]));
        // }

        if (stategame.getstate().sky === true) {

            const speed = 3;

            const difference = HYPERCUBEJS.VECTOR3.subtract([0.8, 0.9, 1.0], this.scene.skybox.color);
            const forward = HYPERCUBEJS.VECTOR3.multiplyscalar(difference, pertick * speed);
            const color = HYPERCUBEJS.VECTOR3.add(this.scene.skybox.color, forward);

            this.scene.setskybox(new HYPERCUBEJS.Skybox('Skybox', color));
            this.scene.setfog(new HYPERCUBEJS.Fog(color, 8, 64, 0.8));
        }

        stateplayer.setstate({

            ...stateplayer.getstate(),
            'jumpcooldown': stateplayer.getstate().jumpcooldown - $timeframe
        });

        if (stateplayer.getstate().jumpcooldown <= 0) {

            stateplayer.setstate({

                ...stateplayer.getstate(),
                'jumping': false
            });
        }

        if (stateplayer.getstate().jumping === true
        && stateplayer.getstate().jump > -2) {

            const jump = stateplayer.getstate().jump - 6 * pertick;

            stateplayer.setstate({

                ...stateplayer.getstate(),
                'jump': jump
            });
        }

        const y = stateplayer.getstate().jump;

        const [x,, z] = HYPERCUBEJS.VECTOR3.rotate(this.$translation, $entity.rotation);
        // const [a, b, c] = HYPERCUBEJS.VECTOR3.normalize([x, y, z]);
        const [a, b, c] = HYPERCUBEJS.VECTOR3.normalize([x, 0, z]);
        $entity.translate([
            parseFloat((a * 6 * pertick).toFixed(16)),
            parseFloat((y * 6 * pertick).toFixed(16)),
            parseFloat((c * 6 * pertick).toFixed(16))
        ]);
        $entity.rotate(HYPERCUBEJS.QUATERNION.fromeuler([
            this.$rotation[0] * HYPERCUBEJS.CONSTANTS.RADIANS * 180 * pertick,
            this.$rotation[1] * HYPERCUBEJS.CONSTANTS.RADIANS * 180 * pertick,
            this.$rotation[2] * HYPERCUBEJS.CONSTANTS.RADIANS * 180 * pertick
        ]));

        $entity.nodes[0].translateself([0, -0.5, -2]);

        const currentrotation = HYPERCUBEJS.QUATERNION.toeuler($entity.nodes[0].rotation);
        let deltarotation = 0;

        const currentrotationx = currentrotation[0] / HYPERCUBEJS.CONSTANTS.RADIANS;

        // console.log(currentrotationx)

        if (
            (currentrotationx + (this.$rotationcamera[0] * 180 * pertick) > -70 && currentrotationx + (this.$rotationcamera[0] * 180 * pertick) < 10)
            || (currentrotationx + (this.$rotationcamera[0] * 180 * pertick) < -170 || currentrotationx + (this.$rotationcamera[0] * 180 * pertick) > 110)
        )
        {

            $entity.nodes[0].rotateself(
                HYPERCUBEJS.QUATERNION.fromeuler([
                    this.$rotationcamera[0] * HYPERCUBEJS.CONSTANTS.RADIANS * 180 * pertick,
                    0,
                    0
                ])
            );

            // console.log(this.$rotationcamera[0] * HYPERCUBEJS.CONSTANTS.RADIANS * 180 * pertick)
        }

        // const currentrotationafter = HYPERCUBEJS.QUATERNION.toeuler($entity.nodes[0].rotation);
        // let deltarotationafter = 0;

        // const currentrotationxafter = currentrotationafter[0] / HYPERCUBEJS.CONSTANTS.RADIANS;

        // console.log(currentrotationxafter)

        // if (currentrotationxafter < -70) {
        //     debugger
        // }
        // else {

        //     console.log($entity.nodes[0].rotation);
        // }

        // console.log(HYPERCUBEJS.QUATERNION.toeuler($entity.nodes[0].rotation)[0] / HYPERCUBEJS.CONSTANTS.RADIANS)

        $entity.nodes[0].translateself([0, 0.5, 2]);

        // if ($entity.translation[1] < -32) {

        //     $entity.translate([0, 64, 0]);
        // }

        // this.$timelightning += $timeframe;

        // if (this.$timelightning > 2300) {

        //     this.$timelightning = 0;

        //     const randomlight = 1;
        //     this.engine.scene.setlightdirectional(new HYPERCUBEJS.LightDirectional('Light Directional', [-0.4, -0.8, -0.2], [randomlight, randomlight, randomlight]));
        //     this.engine.scene.setlightambiant(new HYPERCUBEJS.LightAmbiant('Light Ambiant', [0.2 * randomlight, 0.2 * randomlight, 0.2 * randomlight]));
        //     this.engine.scene.setfog(new HYPERCUBEJS.Fog([0.6 * randomlight, 0.7 * randomlight, 0.8 * randomlight], 0, 32, 1.0));
        //     this.engine.scene.setskybox(new HYPERCUBEJS.Skybox('Skybox', [0.6 * randomlight, 0.7 * randomlight, 0.8 * randomlight]));
        // }

        // if (this.$timelightning > 2000) {

        //     const randomlight = 0.4 + Math.random();
        //     this.engine.scene.setlightdirectional(new HYPERCUBEJS.LightDirectional('Light Directional', [-0.8, -0.2, -0.4], [randomlight, randomlight, randomlight]));
        //     this.engine.scene.setlightambiant(new HYPERCUBEJS.LightAmbiant('Light Ambiant', [0.8 * randomlight, 0.8 * randomlight, 0.8 * randomlight]));
        //     this.engine.scene.setfog(new HYPERCUBEJS.Fog([0.6 * randomlight, 0.7 * randomlight, 0.8 * randomlight], 0, 32, 1.0));
        //     this.engine.scene.setskybox(new HYPERCUBEJS.Skybox('Skybox', [0.6 * randomlight, 0.7 * randomlight, 0.8 * randomlight]));
        // }



        // $entity.lookat([0, 2, 0], [0, 1, 0]);

        this.$rotation = [0, 0, 0];
        this.$rotationcamera = [0, 0, 0];
    }
}

export {

    ScriptPlayer
};

export default ScriptPlayer;
